import { BaseModel } from './BaseModel';

export class Stack extends BaseModel {
  static get entity() {
    return 'stacks';
  }

  static get fk() {
    return 'stack_id';
  }

  static fields() {
    return {
      id: this.uid(),
      title: this.attr(null),
      description: this.attr(null),
      learning_unit_count: this.attr(null),
      status: this.attr(null),
      created_by: this.attr(null),
      created_at: this.attr(null),
      updated_by: this.attr(null),
      updated_at: this.attr(null),
      position: this.attr(null),
      image: this.attr(null),
      learning_units: this.attr([])
    };
  }

  static apiConfig = {
    actions: {
      fetch(params = {}) {
        return this.get(`/stacks`, { params, save: false });
      },
      fetchWithPagination(currentPage, perPage) {
        return this.get(`/stacks`, {
          params: {
            _start: (currentPage - 1) * perPage,
            _limit: perPage
          },
          save: false
        });
      },
      create(data) {
        return this.post(`/stacks`, data, { save: false });
      },
      find(id) {
        return this.get(`/stacks/${id}`, { save: false });
      },
      update(id, data) {
        return this.put(`/stacks/${id}`, data, { save: false });
      },
      delete(id) {
        return this.delete(`/stacks/${id}`, { save: false });
      },
      reorder(data) {
        return this.post(`/stacks/reorder`, data, { save: false });
      },
      findStackDetail(id) {
        return this.get(`/stacks/${id}/detail`, { save: false });
      },
      findStackExplore(limit = null) {
        return this.get(`/stacks/explore`, limit ? { params: { _limit: limit }, save: false } : { save: false });
      }
    }
  };
}

export default Stack;
